import { MODAL_ID_DEFAULT } from '../../../constants/common'
import { MINIMIZED_MODAL_KEY } from '../../Modal'

export const ENTITY_TAB_DOCUMENTS_DEFAULT_FILTER_BAR_PROPS = {
  hideFilterTemplateSkeleton: true,
}

export const QA_NAME_ENTITY_TAB_DOCUMENTS = 'entity_tab_documents'

export const QA_NAME_ENTITY_TAB_DOCUMENTS_UPLOAD = 'entity_tab_documents_upload'

export const QA_NAME_ENTITY_TAB_DOCUMENTS_ADD_FOLDER =
  'entity_tab_documents_add_folder'

export const ENTITY_TAB_DOCUMENTS_MODALS_CONFIG = {
  setEmailFormModal: {
    closer: 'closeEmailFormModal',
    id: MINIMIZED_MODAL_KEY.EMAIL_FORM,
  },
  setModal: { closer: 'closeModal', id: MODAL_ID_DEFAULT },
}
